import React from "react";
import { ArrowRight, Apple, MonitorSmartphone, Play } from "lucide-react";
import { Link } from "react-router-dom";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "@/lib/app-links";

const statusCards = [
  {
    label: "Daily Checks",
    status: "PASS",
    pill: "status-pill-pass",
    title: "Cold Storage Log",
    body: "Morning temperatures recorded in the app and already on the dashboard.",
  },
  {
    label: "Hygiene Audit",
    status: "DUE",
    pill: "status-pill-due",
    title: "Staff Hygiene Review",
    body: "Scheduled from the dashboard, assigned to the team on their phones.",
  },
  {
    label: "Critical Alerts",
    status: "FAIL",
    pill: "status-pill-fail",
    title: "Dishwasher Temp",
    body: "Out-of-range reading raises a deviation with its corrective action.",
  },
];

export default function AppHero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 pt-16 pb-16 md:pt-24 md:pb-20">
        <div className="text-center">
          <p className="app-eyebrow mb-4">One Connected Food-Safety System</p>
          <h1 className="heading-app mb-6 max-w-4xl mx-auto">
            Food Safety Management From Kitchen to Dashboard
          </h1>
          <p className="subheading text-white/80 mb-8 max-w-3xl mx-auto">
            Build and manage your HACCP system online, then give your team the tools to complete
            daily food-safety checks from the Crystal HACCP mobile app. Inspections, temperature
            records, corrective actions and compliance activity are synchronised in one connected
            platform.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6">
            <Link
              to="/auth?mode=signup"
              className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-base font-semibold cta-primary"
            >
              Start your 7-day trial <ArrowRight size={18} />
            </Link>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-base font-semibold border border-white/25 text-white hover:bg-white/10 transition"
            >
              <Apple size={18} /> App Store
            </a>
            <a
              href={GOOGLE_PLAY_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-base font-semibold border border-white/25 text-white hover:bg-white/10 transition"
            >
              <Play size={18} /> Google Play
            </a>
          </div>

          <p className="app-eyebrow !text-white/70">
            Web Dashboard + Mobile App + Regional Compliance
          </p>
          <p className="text-white/60 text-sm mt-3">Available now on iPhone, iPad and Android.</p>
          <p className="text-white/60 text-sm mt-1">
            Built in Oslo. A new product — see exactly what it does below.
          </p>
        </div>

        {/* STATUS CARDS */}
        <div className="grid gap-4 md:grid-cols-3 mt-12">
          {statusCards.map((card) => (
            <div key={card.title} className="app-card p-5">
              <div className="flex items-center justify-between gap-3 mb-3">
                <span className="app-eyebrow !text-white/50">{card.label}</span>
                <span className={`status-pill ${card.pill}`}>{card.status}</span>
              </div>
              <div className="text-white font-semibold text-lg">{card.title}</div>
              <p className="text-white/65 text-sm mt-1.5">{card.body}</p>
            </div>
          ))}
        </div>

        {/* SYNC STRIP */}
        <div className="mt-6 flex items-center justify-center gap-3 rounded-full border border-white/10 bg-white/5 px-5 py-3 text-sm text-white/70">
          <MonitorSmartphone size={18} className="text-crystal-orange shrink-0" />
          <span>Your team records the activity. Management sees the full picture.</span>
        </div>
      </div>
    </section>
  );
}